import React from "react";
import RideDateField from "./RideDateField";
import { styles } from "../../styles";

const PlaceName = ({ children }) => <div style={styles.title}>{children}</div>;

export const OriginField = (ride) => (
  <div style={{ marginBottom: "8px" }}>
    <PlaceName>{ride.originName}</PlaceName>
    <RideDateField ride={ride} type="startDatetime" />
  </div>
);

export const DestinationField = (ride) => (
  <div style={{ marginBottom: "8px" }}>
    <PlaceName>{ride.destinationName}</PlaceName>
    <RideDateField ride={ride} type="endDatetime" />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/fields/RideFields.js